import React from 'react';

import { EffectCount } from '../EffectCount';

import './CountHeading.scss';

type CountHeadingProps = {
    children: React.ReactElement;
    count: number;
    delay?: number;
};

export function CountHeading({ children, count, delay }: CountHeadingProps) {
    return (
        <div className="yat-artifacts__count-heading">
            <var className="yat-artifacts__count-heading__count">
                <EffectCount to={count} delay={delay} />
            </var>
            {children}
        </div>
    );
}
